import { StructureObjectField } from '../../enums/structure-object';

import titleIcon from '../../../images/icons/structure-object/text-icon.svg';
import usersIcon from '../../../images/icons/structure-object/users-icon.svg';
import amountIcon from '../../../images/icons/structure-object/amount-icon.svg';
import companyIcon from '../../../images/icons/structure-object/company-icon.svg';
import clockIcon from '../../../images/icons/structure-object/oclock-icon.svg';
import descIcon from '../../../images/icons/structure-object/description-icon.svg';
import financeIcon from '../../../images/icons/structure-object/finance-icon.svg';
import userIcon from '../../../images/icons/structure-object/user-icon.svg';
import stageIcon from '../../../images/icons/structure-object/stage-icon.svg';
import taskIcon from '../../../images/icons/dark/tasks-icon.svg';
import projectIcon from '../../../images/icons/dark/projects-icon.svg';

export const structureSelling: StructureObjectField[] = [
    {
        key: 'name',
        label: 'Назва',
        order: 1,
        icon: titleIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'clientEmail',
        label: 'Контакт',
        order: 2,
        icon: usersIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'companyName',
        label: 'Компанія',
        order: 3,
        icon: companyIcon,
        visible: true,
    },
    {
        key: 'amount',
        label: 'Бюджет',
        order: 4,
        icon: amountIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'createdAt',
        label: 'Дата створення',
        order: 5,
        icon: clockIcon,
        visible: true,
    },
    {
        key: 'deadline',
        label: 'Дедлайн',
        order: 6,
        icon: clockIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'description',
        label: 'Опис продажі',
        order: 7,
        icon: descIcon,
        visible: true,
    },
    {
        key: 'reponsibleEmail',
        label: 'Відповідальний контакт',
        order: 8,
        icon: userIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'stageName',
        label: 'Етап',
        order: 10,
        icon: stageIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'valutaCode',
        label: 'Валюта',
        order: 11,
        icon: amountIcon,
        visible: true,
    },
    {
        key: 'author',
        label: 'Автор',
        order: 12,
        icon: userIcon,
        visible: true,
    },
];

export const structureSellingOther: StructureObjectField[] = [
    {
        key: 'project',
        label: 'Проєкт',
        order: 1,
        icon: projectIcon,
        visible: true,
    },
    {
        key: 'income',
        label: 'Надходження',
        order: 2,
        icon: financeIcon,
        visible: true,
    },
    {
        key: 'expense',
        label: 'Витрати',
        order: 3,
        icon: financeIcon,
        visible: true,
    },
    {
        key: 'tasks',
        label: 'Завдання',
        order: 4,
        icon: taskIcon,
        visible: true,
    },
]